export enum ClearedFieldsEnum {
  HISTORY = 'history',
  INFO = 'info',
  REVISION = 'revision',
  ROLL = 'roll',
}